export default  {
  data(){
    return {
      enumerate:{
        quoteType:[
          {value:'PQ',label:'Project Quote'},
          {value:'OQ',label:'One-time Deal Quote'}
        ]
      },
    }
  },
  methods:{
    getQuoteType(val){
      if(val==='') return ''
      let text = ''
      this.enumerate.quoteType.forEach((item)=>{
        if(item.value==val){
          text=item.label
        }
      })
      return text
    }
  }
}